import { key } from 'core-ts-types';

export class CIPProgramArea {
  id: key;
  nk: string;
  title: string;

  constructor(cip_program_area: any) {
    _.merge(this, cip_program_area);
    this.id = this.nk;
  }

  static build(cip_program_area: CIPProgramArea): CIPProgramArea {
    return new CIPProgramArea(cip_program_area);
  }
}

angular.module('capability-ng-transfer').factory('ngCIPProgramAreaBuilder', function(): typeof CIPProgramArea {
  return CIPProgramArea;
});



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/cip_program_area_builder.ts